export default function NotFoundPage() {
    return (
        <>
            404 - Page Not Found
        </>
    )
}